import React from 'react';
import { useSelectedMemberContext } from 'js/routes/UserGroups/SelectedMemberContext';
import Checkbox from 'js/components/Forms/Checkbox';

import styles from './CohortList.module.scss';

function CohortMember({ member }) {
  const { isSelected, select } = useSelectedMemberContext();

  const isChecked = isSelected(member.user_group_member.id);

  return (
    <div className={styles.member}>
      <Checkbox
        checked={isChecked}
        onChange={(e) => select(member.user_group_member.id, e.target.checked)}
      >
        {member.user_group_member.name}
      </Checkbox>
    </div>
  );
}

export default CohortMember;
